export const PwaPage = {
  DisabledAndroid: 'DisabledAndroid',
  InstallDesktop: 'InstallDesktop',
  DisabledIos: 'DisabledIos',
  InstallUnavailableOnOldIos: 'InstallUnavailableOnOldIos',
  InstallSafari: 'InstallSafari',
  InstallOldSafari: 'InstallOldSafari',
  InstallChrome: 'InstallChrome',
  InstallYandex: 'InstallYandex',
  InstallOther: 'InstallOther',
};

export type PwaPage = Union<typeof PwaPage>;
